import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const getTCResultsListWithTagsForTSR = async (testSuiteResultId) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No User details found in localStorage");

  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getTCResultsListWithTagsForTSR&testSuiteResultId=${testSuiteResultId}&companyid=${user.companyid}`,
  );
  return response.data;
};

const useGetTCResultsListWithTagsForTSRQuery = (testSuiteResultId, options) => {
  return useQuery({
    queryKey: ["TCResultsListWithTagsForTSR", testSuiteResultId],
    queryFn: () => getTCResultsListWithTagsForTSR(testSuiteResultId),
    enabled: options.enabled,
    ...options,
  });
};

export default useGetTCResultsListWithTagsForTSRQuery;
